import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { PanelOptions } from "@/shared/models/PanelOptions";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "Options"
})
export default class Options extends Vue {
  @Prop() options!: PanelOptions[];

  cardClass = STYLE_CLASSES.CARD;

  showModal(modal: string) {
    this.$emit("showModal", modal);
  }
}
